import React from 'react';
import { NavLink } from 'react-router-dom';

const FoundationHeader = () => {
  const navItems = [
    { name: 'Inicio', path: '/' },
    { name: 'Nosotros', path: '/nosotros' },
    { name: 'Misión y Visión', path: '/mision-vision' },
    { name: 'Qué Hacemos', path: '/que-hacemos' },
    { name: 'Contacto', path: '/contacto' },
  ];

  return (
    <header className="w-full bg-gradient-to-r from-green-700 to-green-900 shadow-md p-4 md:p-6 flex flex-col md:flex-row justify-between items-center fixed top-0 z-50">
      
      {/* Logo y nombre */}
      <div className="flex items-center gap-3 mb-4 md:mb-0 text-center">
        <img
          src="/logo.png"
          alt="Logo Fundación"
          className="w-20 h-20 md:w-20 md:h-20 object-contain"
        />
        <h1 className="text-lg md:text-2xl font-bold text-yellow-300 drop-shadow-md leading-tight">
          <span className="block">Fundación Regional de Desarrollo</span>
          <span className="block">Afrocolombiana Sol Caribe</span>
        </h1>
      </div>

      {/* Navegación */}
      <nav className="flex flex-wrap justify-center md:justify-end gap-4 md:gap-6">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `text-base md:text-lg font-medium transition duration-300 ${
                isActive
                  ? 'text-yellow-300 font-semibold'
                  : 'text-white hover:text-yellow-300'
              }`
            }
          >
            {item.name}
          </NavLink>
        ))}
      </nav>
    </header>
  );
};

export default FoundationHeader;
